import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M24.155 3a9.67 9.67 0 0 0-6.766 2.746 9.28 9.28 0 0 0-2.803 6.63v5.221h-5.12a.46.46 0 0 0-.466.456v6.894a.46.46 0 0 0 .466.456h5.12v14.14a.46.46 0 0 0 .466.457h7.034a.46.46 0 0 0 .466-.456V25.403h5.166c.213 0 .4-.142.451-.345l1.759-6.893a.45.45 0 0 0-.085-.392.46.46 0 0 0-.366-.176h-6.925v-5.22a1.54 1.54 0 0 1 .47-1.111 1.6 1.6 0 0 1 1.133-.46h5.38a.46.46 0 0 0 .465-.457V3.456A.46.46 0 0 0 29.535 3z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }